import UnSaveIcon from "../../../assets/images/svgicons/unsave.svg";
import SaveIcon from "../../../assets/images/svgicons/save.svg";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
  Carousel,
} from "alm-react-components";
import defaultImg from '../../../assets/images/default-image-library.png';
import PlayIcon from '../../../assets/images/svgicons/play.svg';

import { useTranslation } from "react-i18next";
import { apis } from "../../../services/alm";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import {  DateFormat, Tag } from "../../../assets/constants/constants";
import getLocalizedContent from '../../../lib/getLocalizedMetaData';
import useLibrarySeeAll from "../../../hooks/useLibrarySeeAll";
import moment from "moment-timezone";

/**
 * Loding releted content,
 * courseId : couserId will either course and mail lp program id
 */
type RelatedContentProps = {
  courseId: string;
}
const RelatedContent: React.FC<RelatedContentProps> = ({ courseId }) => {
  const [relatedContentData, setRelatedContentData] = useState<any>([]);
  const { bookMarkresponse, deleteBookMark, addBookMark } = useLibrarySeeAll();
  const navigate = useNavigate()
  const [query] = useSearchParams()
  const sequenceId = query.get("sequence")

  const fetchRelatedContent = async () => {
    const relatedContent = await apis.getRelatedContent(courseId);
    const response = relatedContent.data;
    setRelatedContentData(response);
  };
  const { t } = useTranslation();
  useEffect(() => {
    fetchRelatedContent();
  }, [courseId, bookMarkresponse]);
  const handleRedirection = async (id: any) => {
    const response: any = await apis.getProgramList(id);
    if (response) {
      await apis.userEnroll(id, response?.data?.relationships?.instances?.data[0].id);
    }
    {
      navigate(
        `/home/library/library-course/${id}?`, {
        state: {
          courseType: "relatedContent",
          relatedId: courseId,
          from: (window.location.pathname.split('/')[1]==="program") ? `${window.location.pathname}` : `${window.location.pathname}?sequence=${sequenceId}`
        }
      }
      )
    }
  }
  return (
    <>
    {relatedContentData.length > 0 && (
    <section className="w-[100%] mx-auto xl:px-32 lg:px-8 md:px-8 px-5 py-6 md:py-14">
      <>
        <h2 className="text-3xl font-barlowLight border-t pt-16">{t('Library.relatedContent')}</h2>
        <Carousel className="mt-12 carousel-container">
          <CarouselContent className="lg:flex-row lg:gap-0 md:flex md:flex-row">
            {relatedContentData &&
              relatedContentData?.map((course: any, index: number) => {
                const content = getLocalizedContent(course?.attributes?.localizedMetadata);
                const releaseDate = course?.attributes?.tags
                  ?.filter((item: any) => item?.split(':')[0] === Tag.releaseDate)[0]
                  ?.split(':')[1];
                return (
                  <CarouselItem key={`related-content-${index}`} className="min-w-0 shrink-0 grow-0 basis-full pl-4 landscape:2xl:basis-1/4 landscape:xl:basis-1/4 landscape:lg:basis-1/3 landscape:md:basis-1/2 portrait:md:basis-1/2 landscape:sm:basis-1/2 portrait:sm:basis-1/2 md:pl-5">
                    <Card className="w-full h-full p-0 bg-fillMidGrayCard border-cardBorder relative rounded-lg">
                      <CardHeader className="p-0" onClick={() => handleRedirection(course?.id)} >
                        <div className="relative cursor-pointer">
                          {course?.attributes?.imageUrl ? (
                            <img
                              src={course?.attributes?.imageUrl}
                              alt={" "}
                              className="rounded-t-lg w-full h-full aspect-[3/2] object-cover"
                            />
                          ) : (
                            <img
                              src={defaultImg}
                              alt={" "}
                              className="rounded-t-lg w-full h-full aspect-[3/2] object-cover"
                            />
                          )}
                            <img src={PlayIcon} alt={' '} className="absolute center-icon" />

                        </div>
                      </CardHeader>
                      <CardContent className="mt-4 px-5">
                        <div className="flex flex-row items-start justify-between mt-2 h-full break-words">
                          <div className="flex flex-col justify-between">
                            <div className="flex flex-col">
                              <CardTitle className="text-wrap lg:text-xl xl:text-2xl font-barlowLight line-clamp-2 tracking-normal max-sm:leading-6">
                                {content?.name}
                              </CardTitle>
                              <p className="lg:text-base xl:text-lg font-sans mt-3 mb-16 flex-grow line-clamp-2 leading-6">
                                {
                                  content
                                    ?.description
                                }
                              </p>
                            </div>
                            <p className="text-base font-opensansMedium absolute bottom-6">
                              {/* {formatDate(releaseDate?releaseDate:"")} */}
                                <span className="capitalize">
                                  {releaseDate && moment(releaseDate).isValid() ? moment(releaseDate).format(DateFormat) : ""}
                                </span>
                            </p>
                          </div>
                          <img
                            onClick={e => {
                              e.stopPropagation();
                              // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                              course.attributes?.isBookmarked
                                ? deleteBookMark(course?.id)
                                : addBookMark(course?.id);
                            }}
                            src={course?.attributes?.isBookmarked ? SaveIcon : UnSaveIcon}
                            alt="No image"
                            className="ms-5 cursor-pointer"
                          />
                        </div>
                      </CardContent>
                    </Card>
                  </CarouselItem>
                );
              })}
          </CarouselContent>
          <div className="carousel-prev-next-box">
            <CarouselPrevious className="carousel-prev-btn top-full mt-5 translate-y-0" />
            <CarouselNext className="carousel-next-btn right-0 top-full bottom-0 mt-5 translate-y-0" />
          </div>
        </Carousel>
      </>
    </section>
      )}
      </>
  );
};

export default RelatedContent;
